<template>
  <section class="search">
    <article class="search__container container">
      <div v-if="error.show" class="error container">
        <p class="error-message">{{ error.msg }}</p>
      </div>
 
      <form @submit="handleSubmit" autocomplete="off">
        <div class="form-control">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input
            type="text"
            v-model="user"
            name="user"
            placeholder="Enter Github user"
          />
          <button type="submit">Search</button>
        </div>
      </form>

      <h3>Request: {{ this.requests }} / 60</h3>
    </article>
  </section>
</template>

<script>
export default {
  name: "UserSearch",

  data() {
    return {
      user: "",
    };
  },

  props: {
    requests: Number,
    error: Object,
    isLoading: Boolean,
    searchGithubUser: Function,
  },

  methods: {
    handleSubmit(event) {
      event.preventDefault();
      this.searchGithubUser(this.user);
      this.user = "";
    },
  },
};
</script>

<style scoped lang="scss">
.search {
  .error {
    position: absolute;
    width: 90vw;
    top: 0;
    left: 0;
    transform: translateY(-100%);
    text-transform: capitalize;
    p {
      color: var(--clr-red-dark);
      letter-spacing: var(--spacing);
      background-color: var(--clr-red-light);
      width: fit-content;
    }
  }
  &__container {
    position: relative;
    display: grid;
    gap: 1rem 1.75rem;
    @media (min-width: 768px) {
      grid-template-columns: 1fr max-content;
      align-items: center;
      h3 {
        padding: 0 0.5rem;
      }
    }
  }
  .form-control {
    background: var(--clr-white);
    display: grid;
    align-items: center;
    grid-template-columns: auto 1fr auto;
    column-gap: 0.5rem;
    border-radius: 5px;
    padding: 0.5rem;

    input {
      border-color: transparent;
      outline-color: var(--clr-grey-10);
      letter-spacing: var(--spacing);
      color: var(--clr-grey-3);
      padding: 0.25rem 0.5rem;
      outline: none;
    }

    input::placeholder {
      color: var(--clr-grey-3);
      text-transform: capitalize;
      letter-spacing: var(--spacing);
      font-size: var(--small-font-size);
    }

    button {
      border-radius: 5px;
      border-color: transparent;
      padding: 0.25rem 0.5rem;
      text-transform: capitalize;
      letter-spacing: var(--spacing);
      background: var(--clr-primary-5);
      color: var(--clr-white);
      transition: var(--transition);
      cursor: pointer;

      &:hover {
        background: var(--clr-primary-8);
        color: var(--clr-primary-1);
      }
    }

    svg {
      color: var(--clr-grey-5);
    }
    input,
    button,
    svg {
      font-size: 1.1rem;
    }
    @media (max-width: 800px) {
      button,
      input,
      svg {
        font-size: 0.85rem;
      }
    }
  }
}
</style>
